import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";
import ChatRoomInputPanel from "../../ChatRoomInputPanel";
import ChatRoomMediaWrapper from "./ChatRoomMediaWrapper";

interface Props {
  images: string[];
  documents: string[];
  videos: string[];
  onClickRemoveImage: (image: string) => void;
  onClickRemoveDocument: (document: string) => void;
  onClickRemoveVideo: (video: string) => void;
}

function ChatRoomAttachmentsBar(props: Props) {
  const [imagesAutoAnimateRef] = useAutoAnimate<HTMLDivElement>();
  const shouldPanelBeHidden =
    props.images.length === 0 && props.documents.length === 0 && props.videos.length === 0;

  return (
    <ChatRoomInputPanel.Attachments ref={imagesAutoAnimateRef} hidden={shouldPanelBeHidden}>
      {props.images.map((image) => (
        <ChatRoomMediaWrapper
          key={image}
          type="image"
          media={image}
          onClick={() => props.onClickRemoveImage(image)}
        ></ChatRoomMediaWrapper>
      ))}
      {props.documents.map((document) => (
        <ChatRoomMediaWrapper
          key={document}
          type="document"
          media={document}
          onClick={() => props.onClickRemoveDocument(document)}
        ></ChatRoomMediaWrapper>
      ))}
      {props.videos.map((video) => (
        <ChatRoomMediaWrapper
          key={video}
          type="video"
          media={video}
          onClick={() => props.onClickRemoveVideo(video)}
        ></ChatRoomMediaWrapper>
      ))}
    </ChatRoomInputPanel.Attachments>
  );
}

export default ChatRoomAttachmentsBar;
